// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import ElementUI from 'element-ui'; //element-ui引入
import Mint from 'mint-ui'; //mint-ui引入
import cookie from 'js-cookie'; //js-cookie引入
import {post, get, put, del,dels, patch} from './utils/https'; //调用接口方法
import "babel-polyfill";
import Viewer from 'v-viewer'; //预览图片
import * as imageConversion from 'image-conversion'; //处理图片
import VueCropper from 'vue-cropper';
import store from './store/store.js';//引用vuex
import registerDirectives from './directives/index.js';
// 通用方法
import {
  deleteUidItem,
  exportExcel,
  RsaCode,
  getTime,
  formatDate,
  compareTime,
  checkData,
  getCaption,
  createOssClient,
  dateFormat,
  randomString,
  errorImage,
  handleExceed,
  beforePicUpload,
  cdnFun,
  checkCdnProgress,
  convertVideo,
  propMessage,
  successMessage,
  warnMessage,
  getDay,
  errorMessage
} from './utils/fn'

// 样式
import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/theme-chalk/display.css';
import 'mint-ui/lib/style.css';
import 'viewerjs/dist/viewer.css'
import './assets/fonts/iconfont.css';
import '../src/assets/css/common.css';
import '../src/assets/css/reset.less';
import '../src/assets/css/customize.less';

import global_ from './utils/global.js';// 引用文件
import address from './utils/dataAddress.vue';//
import Toast from './components/toast/toast'
import dayjs from 'dayjs'
// 全局使用
Vue.config.productionTip = false;
Vue.use(ElementUI);
// 图片预览
Vue.use(Viewer, {
  defaultOptions: {
    zIndex: 9999
  }
});
Vue.use(VueCropper)

Vue.prototype.$Toast = Toast;
Vue.prototype.$dayjs = dayjs;
// 插件
Vue.prototype.$imageConversion = imageConversion;
Vue.prototype.$Mint = Mint;
Vue.prototype.$cookie = cookie;
Vue.prototype.$store = store;
// });
//接口調用方法
Vue.prototype.$post = post;
Vue.prototype.$get = get;
Vue.prototype.$put = put;
Vue.prototype.$del = del;
Vue.prototype.$dels = dels;
Vue.prototype.$patch = patch;
// 定义全局变量
Vue.prototype.$GLOBAL = global_;
Vue.prototype.$Address = address
// 全局方法
Vue.prototype.$deleteUidItem = deleteUidItem;// 根据数组某一元素的uid删除本元素
Vue.prototype.$exportExcel = exportExcel;//导出excel
Vue.prototype.$RsaCode = RsaCode;// 加密
Vue.prototype.$getTime = getTime;// 时间戳转换
Vue.prototype.$formatDate = formatDate;// 标准时间转为字符串时间
Vue.prototype.$compareTime = compareTime;// 比较两个时间的大小
Vue.prototype.$checkData = checkData;// 校验文件格式是否为excel
Vue.prototype.$getCaption = getCaption;// // 判断非法字符
Vue.prototype.$createOssClient = createOssClient;
Vue.prototype.$dateFormat = dateFormat;
Vue.prototype.$randomString = randomString;
Vue.prototype.$errorImage = errorImage;//上傳圖片出現錯誤
Vue.prototype.$handleExceed = handleExceed;//上传图片超出限制
Vue.prototype.$beforePicUpload = beforePicUpload;//上传图片之前回调函数
Vue.prototype.$cdnFun = cdnFun;//cdn预热上传接口
Vue.prototype.$checkCdnProgress = checkCdnProgress; //cdn预热上传进度查询接口
Vue.prototype.$convertVideo = convertVideo; //视频转码接口
Vue.prototype.$getDay = getDay;//获取时间范围
// 全局提示
Vue.prototype.$propMessage = propMessage;
Vue.prototype.$warnMessage = warnMessage;
Vue.prototype.$errorMessage = errorMessage;
Vue.prototype.$successMessage = successMessage;
registerDirectives(Vue)
//全局事件总线
const bus = new Vue()
Vue.prototype.$bus = bus
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js